export class FinanceOfficeWriterError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'FinanceOfficeWriterError';
    this.code = code;
  }
}

export function writerError(code, message) {
  return new FinanceOfficeWriterError(code, message);
}

export function abortError() {
  const error = new Error('Finance Office operation was cancelled');
  error.name = 'AbortError';
  return error;
}

export function assertNotAborted(signal) {
  if (signal?.aborted) throw abortError();
}

export async function assertCurrentDocumentIdentity(assertCurrentIdentity) {
  if (typeof assertCurrentIdentity === 'function') {
    await assertCurrentIdentity();
  }
}

export function targetDrift(message = 'Finance Office target changed before commit') {
  return writerError('finance_office_target_drift', message);
}

export function verificationFailed() {
  return writerError(
    'finance_office_verification_failed',
    'Finance Office operation could not be verified'
  );
}

export function excelRangeAddress(anchorCell, rowCount, columnCount) {
  const match = /^([A-Z]{1,3})([1-9]\d{0,6})$/.exec(anchorCell);
  if (!match || !Number.isSafeInteger(rowCount) || !Number.isSafeInteger(columnCount)) {
    throw writerError(
      'invalid_finance_office_operation',
      'Excel target range is invalid'
    );
  }
  const startColumn = [...match[1]].reduce(
    (total, character) => (total * 26) + character.charCodeAt(0) - 64,
    0
  );
  const endColumn = startColumn + columnCount - 1;
  const endRow = Number(match[2]) + rowCount - 1;
  if (endColumn > 16_384 || endRow > 1_048_576) {
    throw writerError(
      'invalid_finance_office_operation',
      'Excel target range is outside worksheet bounds'
    );
  }
  let value = endColumn;
  let columnName = '';
  while (value > 0) {
    value -= 1;
    columnName = String.fromCharCode(65 + (value % 26)) + columnName;
    value = Math.floor(value / 26);
  }
  return `${anchorCell}:${columnName}${endRow}`;
}

export function cellIsEmpty(value, formula) {
  const valueEmpty = value === '' || value === null || value === undefined;
  const formulaEmpty = formula === '' || formula === null || formula === undefined;
  return valueEmpty && formulaEmpty;
}

export function scalarMatches(expected, actual) {
  if (expected === null) return actual === '' || actual === null;
  if (typeof expected === 'number') {
    return typeof actual === 'number' && Object.is(expected, actual);
  }
  return expected === actual;
}

const LICENSED_DATA_SENTINEL = 'Source: Daloopa |';

export function containsLicensedDataEvidence(value) {
  if (typeof value === 'string') {
    return value.includes(LICENSED_DATA_SENTINEL);
  }
  if (Array.isArray(value)) {
    return value.some(containsLicensedDataEvidence);
  }
  return false;
}
